import { makeStyles } from "@material-ui/core/styles";
//
import imgSvg from "../../lib/wild-underline-2.svg";
import imgSmile from "../../lib/pexels_diva_plavalaguna_2.jpg";
//Cart.js

//
//
//
export default makeStyles((theme) => ({
  deletedCartPage: {
    // backgroundColor: "pink",
    border: "5px solid #121212",
    boxShadow: "10px 11px 0px 1px  #00ffb3",
    //
    width: "100%",
    position: "relative",
    height: "75vh",

    //
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexFlow: "column",
    //
    backgroundRepeat: "no-repeat",
    backgroundImage: `url(${imgSmile})`,
    backgroundPosition: "center",
    backgroundSize: "cover",
    //
    //
    transition: "all 2s ease",
    borderRadius: "147px 40px 151px 40px",
    //
    opacity: "0.7",

    "&::after": {
      transition: "all 2s ease",
      content: '""', // you need to have it really like this '""',
      width: "100%",
      height: "100%",
      top: "0",
      left: "0",
      position: "absolute",
      opacity: "0.9",
      pointerEvents: "none",
      //  imgSvg
      backgroundRepeat: "no-repeat",
      backgroundImage: `url(${imgSvg})`,
      // backgroundAttachment: "fixed",
      backgroundPosition: "center",
      backgroundSize: "110%",
      //
    },
    [theme.breakpoints.down("xs")]: {
      height: "40vh",
      padding: "40px 0",
      marginTop: "100px",
      transition: "all 2s ease",
    },
  },
  //
  //
  //
  //    *** YOUR SHOPPING CART IS EMPTY!
  //
  titleDeletedCart: {
    color: "rgba(255, 251, 166, 0.86)",
    //yellow overlay img
    fontFamily: "RobotoBlack",
    textAlign: "center",
    fontSize: `calc(40px + 1.1vmin)`,
    lineHeight: `calc(48px + 1.1vmin)`,
    fontWeight: "600",
    //mobile
    [theme.breakpoints.down("xs")]: {
      width: "80%",
      wordWrap: "breakWord",
      wordSpacing: "5px",
      fontSize: `calc(32px + 1.1vmin)`,
      lineHeight: `calc(30px + 1.1vmin)`,
      marginBottom: "30px",
    },
    [theme.breakpoints.up("sm")]: {
      width: "70%",
      wordWrap: "breakWord",
      wordSpacing: "5px",
      fontSize: `calc(48px + 1.1vmin)`,
      lineHeight: `calc(47px + 1.1vmin)`,
      marginBottom: "20px",
    },
    [theme.breakpoints.up("md")]: {
      width: "70%",
      wordWrap: "breakWord",
      wordSpacing: "5px",
      fontSize: `calc(56px + 1.1vmin)`,
      lineHeight: `calc(55px + 1.1vmin)`,
      marginBottom: "20px",
    },
    [theme.breakpoints.up("lg")]: {
      width: "70%",
      wordWrap: "breakWord",
      wordSpacing: "5px",
      fontSize: `calc(56px + 1.1vmin)`,
      lineHeight: `calc(55px + 1.1vmin)`,
      marginBottom: "20px",
    },
  },

  toolbar: theme.mixins.toolbar,

  //--------------------------------
  //
  //
  //        *** START ADDING some
  link: {
    textDecoration: "none",
    textTransform: "capitalize",
    fontFamily: "PoppinsThin",
    color: "rgb(248, 248, 248)",
    fontSize: `calc(24px + 1vmin)`,
    lineHeight: `calc(24px + 1.1vmin)`,
    fontWeight: "600",
    letterSpacing: "1px",
    //
    listStyle: "none",

    position: "relative",
    zIndex: "1",
    paddingBottom: "3px",

    //
    "&::after": {
      content: '""', // you need to have it really like this '""',
      position: "absolute",
      width: "100%",
      transform: `scaleX(0)`,
      height: "5px",
      bottom: "0",
      left: "0",

      backgroundColor: "rgba(255, 221, 0, 0.874)",
      /*line color*/
      transformOrigin: "bottom right",
      transition: "transform 0.35s ease-out",
      paddingBottom: "3px",
    },
    "&:hover": {
      "&:after": {
        transform: `scaleX(1)`,
        transformOrigin: "bottom left",
      },
    },

    //mobile
    [theme.breakpoints.down("xs")]: {
      width: "80%",
      wordWrap: "breakWord",
      fontSize: `calc(18px + 1vmin)`,
      lineHeight: `calc(22px + 1.1vmin)`,
    },
    //
  },
  cardDetails: {
    display: "flex",
    marginTop: "10%",
    width: "100%",
    justifyContent: "space-between",
    margin: "1% 0% 2% 0%",
  },
}));

// https://mui.com/customization/color/
